<template>
	 <div>
	 <div class="wrap" v-if="isMobile">
		<div class="mIdcard">
			<h2><span @click="showPopover()">实名认证 <em class="icon3 icon3-question"></em></span></h2>
			<p>基本信息：</p>
			<ul>
                    <li> <span><font color="#ff0000">*</font> 姓名：</span><div class="input-item"><el-input :disabled="isabled" @blur="VerifyName()" size="small" v-model="name" :class="msg==''?'':'red'" placeholder="请输入姓名"></el-input><div class="msg">{{msg}}</div></div></li>
                    <li> <span><font color="#ff0000">*</font> 证件号：</span>
						<div class="input-item1">
							<el-input :disabled="isabled" placeholder="请输入证件号" @blur="VerifyCertificate()" v-model="idcard" size="small" :class="msg1==''?'input-with-select':' input-with-select red'">
								<el-select v-model="selectType" slot="prepend" :disabled="isabled">
									<el-option label="身份证号" value="身份证号"></el-option>
									<el-option label="香港澳门居民身份证" value="香港澳门居民身份证"></el-option>
									<el-option label="台湾身份证" value="台湾身份证"></el-option>
									<el-option label="外国护照" value="外国护照"></el-option>
								</el-select>
							</el-input>
							<div class="msg1">{{msg1}}</div>
						</div>
                    </li>
			</ul>
			<p>上传证件：</p>
			<div class="upload">
                <dl>
                    <dt>上传证件正面照片
						<template v-if="status==10">
							<font color="#ff0000">（审核中）</font>
						</template>
						<template v-if="status==12">
							<font color="#ff0000">（重新提交）</font>
						</template>
					</dt>
                    <dd>
						<template v-if="status==0 || status==12">
							<el-upload
							class="avatar-uploader"
							ref="upload"
							:action="domain"
							accept="image/jpeg,image/gif,image/png,image/bmp"
							:headers="myHeader"
							:http-request="uploadFile"
							:on-change="changeFile"
							:show-file-list="false"
							:auto-upload="true"
							list-type="picture"
							:multiple="false">
							<template v-if="BinaryImg"><img :src="BinaryImg" class="avatar" ></template>
							<template v-else> <img src="/static/images/FrontDefault.png" width="200" /></template>
							</el-upload>
						</template>
						<template v-else>
							<i @click="showExample1(1,true)"><img :src="BinaryImg" width="180" height="108" /></i>
						</template>

						<div class="clear"></div>
						<span class="example" @click="showExample(1,true)">查看示例</span></dd>
                </dl>
                <dl>
                    <dt>上传证件反面照片
						<template v-if="status==10">
							<font color="#ff0000">（审核中）</font>
						</template>
						<template v-if="status==12">
							<font color="#ff0000">（重新提交）</font>
						</template>
					</dt>
                    <dd>
						<template v-if="status==0 || status==12">
						<el-upload
							class="avatar-uploader"
							ref="upload"
							:action="domain"
							accept="image/jpeg,image/gif,image/png,image/bmp"
							:headers="myHeader"
							:http-request="uploadFile1"
							:on-change="changeFile1"
							:show-file-list="false"
							:auto-upload="true"
							list-type="picture"
							:multiple="false">
							<template v-if="BinaryImg1"><img :src="BinaryImg1" class="avatar" ></template>
							<template v-else> <img src="/static/images/BackDefault.png" width="200" /></template>
						</el-upload>
						</template>
						<template v-else>
							<i @click="showExample1(2,true)"><img :src="BinaryImg1" width="180" height="108" /></i>
						</template>
					<div class="clear"></div>
					<span class="example" @click="showExample(2,true)">查看示例</span></dd>
                </dl>
                <dl class="last">
                    <dt>上传手持证件照片
						<template v-if="status==10">
							<font color="#ff0000">（审核中）</font>
						</template>
						<template v-if="status==12">
							<font color="#ff0000">（重新提交）</font>
						</template>
					</dt>
                    <dd>
					<template v-if="status==0 || status==12">
					<el-upload
							class="avatar-uploader"
							ref="upload"
							:action="domain"
							accept="image/jpeg,image/gif,image/png,image/bmp"
							:headers="myHeader"
							:http-request="uploadFile2"
							:on-change="changeFile2"
							:show-file-list="false"
							:auto-upload="true"
							list-type="picture"
							:multiple="false">
							<template v-if="BinaryImg2"><img :src="BinaryImg2" class="avatar" ></template>   <!-- <i><img src="images/1.jpg" /></i> -->
							<template v-else> <img src="/static/images/HeldDefault.png" width="200" /></template>
					</el-upload>
					</template>
					<template v-else>
						<i @click="showExample1(3,true)"><img :src="BinaryImg2" width="180" height="108" /></i>
					</template>
					<div class="clear"></div>
					<span class="example" @click="showExample(3,true)">查看示例</span></dd>
                </dl>
                </div>
				<div class="clear"></div>
                <div class="btn">
					<template v-if="status==0">
						<button @click="save()">提交审核</button>
					</template>
					<template v-else-if="status==10">
						<button class="unable" :disabled="isabled">审核中</button>
					</template>
					<template v-else-if="status==11">
						<router-link class="ant-form-item" to="/home" >审核已通过，去首页</router-link>
					</template>
					<template v-else-if="status==12">
						<button @click="save()">重新提交审核</button>
						<div class="comment">您的实名认证未通过审核，{{comment}}</div>
					</template>
				</div>

		</div>
	 </div>
	 <div class="content" v-else>
            <div class="idcard">
                <h2><span>实名认证</span>
				 <el-popover
					placement="bottom"
					title="为什么要实名认证？"
					width="320"
					trigger="hover"
					content="实名认证通过后才能参加游戏代练师技能认定考试，我们会严格保密您的个人信息。"
					v-model="visible">
					<em class="icon3 icon3-question" slot="reference" ></em>
				</el-popover>
				</h2>
                <p>基本信息：</p>
                <ul>
                    <li><font color="#ff0000">*</font> 姓名：<div class="input-item"><el-input :disabled="isabled" @blur="VerifyName()" size="small" v-model="name" :class="msg==''?'':'red'" placeholder="请输入姓名"></el-input><div class="msg">{{msg}}</div></div></li>
                    <li><font color="#ff0000">*</font> 证件号：
						<div class="input-item1">
							<el-input :disabled="isabled" placeholder="请输入证件号" @blur="VerifyCertificate()" v-model="idcard" size="small" :class="msg1==''?'input-with-select':' input-with-select red'">
								<el-select v-model="selectType" slot="prepend" :disabled="isabled">
									<el-option label="身份证号" value="身份证号"></el-option>
									<el-option label="香港澳门居民身份证" value="香港澳门居民身份证"></el-option>
									<el-option label="台湾身份证" value="台湾身份证"></el-option>
									<el-option label="外国护照" value="外国护照"></el-option>
								</el-select>
							</el-input>
							<div class="msg1">{{msg1}}</div>
						</div>
                    </li>
                </ul>
                <p>上传证件：</p>

                <div class="upload">
                <dl>
                    <dt>上传证件正面照片
						<template v-if="status==10">
							<font color="#ff0000">（审核中）</font>
						</template>
						<template v-if="status==12">
							<font color="#ff0000">（重新提交）</font>
						</template>
					</dt>
                    <dd>
						<template v-if="status==0 || status==12">
							<el-upload
							class="avatar-uploader"
							ref="upload"
							:action="domain"
							accept="image/jpeg,image/gif,image/png,image/bmp"
							:headers="myHeader"
							:http-request="uploadFile"
							:on-change="changeFile"
							:show-file-list="false"
							:auto-upload="true"
							list-type="picture"
							:multiple="false">
							<template v-if="BinaryImg"><img :src="BinaryImg" class="avatar" ></template>
							<template v-else> <img src="/static/images/FrontDefault.png" width="200" /></template>
							</el-upload>
						</template>
						<template v-else>
							<i @click="showExample1(1)"><img :src="BinaryImg" width="180" height="108" /></i>
						</template>

						<div class="clear"></div>
						<span class="example" @click="showExample(1)">查看示例</span></dd>
                </dl>
                <dl>
                    <dt>上传证件反面照片
						<template v-if="status==10">
							<font color="#ff0000">（审核中）</font>
						</template>
						<template v-if="status==12">
							<font color="#ff0000">（重新提交）</font>
						</template>
					</dt>
                    <dd>
						<template v-if="status==0 || status==12">
						<el-upload
							class="avatar-uploader"
							ref="upload"
							:action="domain"
							accept="image/jpeg,image/gif,image/png,image/bmp"
							:headers="myHeader"
							:http-request="uploadFile1"
							:on-change="changeFile1"
							:show-file-list="false"
							:auto-upload="true"
							list-type="picture"
							:multiple="false">
							<template v-if="BinaryImg1"><img :src="BinaryImg1" class="avatar" ></template>
							<template v-else> <img src="/static/images/BackDefault.png" width="200" /></template>
						</el-upload>
						</template>
						<template v-else>
							<i @click="showExample1(2)"><img :src="BinaryImg1" width="180" height="108" /></i>
						</template>
					<div class="clear"></div>
					<span class="example" @click="showExample(2)">查看示例</span></dd>
                </dl>
                <dl class="last">
                    <dt>上传手持证件照片
						<template v-if="status==10">
							<font color="#ff0000">（审核中）</font>
						</template>
						<template v-if="status==12">
							<font color="#ff0000">（重新提交）</font>
						</template>
					</dt>
                    <dd>
					<template v-if="status==0 || status==12">
					<el-upload
							class="avatar-uploader"
							ref="upload"
							:action="domain"
							accept="image/jpeg,image/gif,image/png,image/bmp"
							:headers="myHeader"
							:http-request="uploadFile2"
							:on-change="changeFile2"
							:show-file-list="false"
							:auto-upload="true"
							list-type="picture"
							:multiple="false">
							<template v-if="BinaryImg2"><img :src="BinaryImg2" class="avatar" ></template>   <!-- <i><img src="images/1.jpg" /></i> -->
							<template v-else> <img src="/static/images/HeldDefault.png" width="200" /></template>
					</el-upload>
					</template>
					<template v-else>
						<i @click="showExample1(3)"><img :src="BinaryImg2" width="180" height="108" /></i>
					</template>
					<div class="clear"></div>
					<span class="example" @click="showExample(3)">查看示例</span></dd>
                </dl>
                </div>
                <div class="clear"></div>
                <div class="btn">
					<template v-if="status==0">
						<button @click="save()">提交审核</button>
					</template>
					<template v-else-if="status==10">
						<button class="unable" :disabled="isabled">审核中</button>
					</template>
					<template v-else-if="status==11">
						<router-link class="ant-form-item" to="/home" >审核已通过，去首页</router-link>
					</template>
					<template v-else-if="status==12">
						<button @click="save()">重新提交审核</button>
						<div class="comment">您的实名认证未通过审核，{{comment}}</div>
					</template>
				</div>

				<!-- <div class="btn"><button class="unable" disabled="disabled">审核中</button></div> -->
            </div>
        </div>
	</div>
</template>
<style scoped>
/*  实名认证  */
.idcard{background:#fff; overflow:hidden;padding-bottom:64px; margin-top:20px;}
.idcard h2{ height:68px; line-height:68px; font-size:24px; padding-left:421px; border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal;}
.idcard h2 span{ float:left;}
.idcard em{ display:inline-block; margin-top:26px; margin-left:5px;}
.idcard p{ padding-top:28px; font-size:16px; padding-left:24px; font-weight:bold;}
.idcard ul{  padding:20px 70px 50px;}
.idcard li{float:left; width:50%;font-size:14px; }
.idcard .upload{padding:0 70px;}
.idcard dl{ float:left;  font-size:14px; padding-right:109px;}
.idcard dl.last{ padding-right:0;}
.idcard dt{padding-top:34px;}
.idcard i{ display:block; width:180px; height:108px; padding:10px; background:#f0eee7; border-radius:5px;margin:15px 0; cursor: pointer;}
.idcard .example{ color:#18abff; display:block; cursor: pointer;}
.idcard .btn{text-align:center; margin-top:64px; width:100%;}
.idcard button{width:360px; height:40px; line-height:40px;text-align:center; font-size:16px;border:solid 1px #1890ff; background:#1890ff;color:#fff;border-radius: 5px; cursor: pointer;}
.idcard .ant-form-item{display:block; margin: 0 auto; width:360px; height:40px; line-height:40px;text-align:center; font-size:16px;border:solid 1px #1890ff; background:#1890ff;color:#fff;border-radius: 5px; cursor: pointer;}
.idcard button.unable{border:solid 1px #d9d9d9; background:#f5f5f5;color:#b7b7b7;}
.idcard .comment{margin-top: 24px; font-size: 14px;}

.idcard .input-item{ width:296px; display: inline-block; }
.idcard .input-item1{display: inline-block; position: relative;}
.idcard input{height:20px;}
.idcard .msg{font-size:14px; color:#f5222d; line-height:24px; position: absolute;}
.idcard .msg1{font-size:14px; color:#f5222d; line-height:24px; position: absolute; left:130px;}

.avatar-uploader{cursor:pointer;overflow:hidden; float: left; vertical-align: bottom;}
.avatar-uploader-icon:hover {border-color:#409EFF;}
.avatar-uploader-icon {font-size:38px;color:#8c939d;width:128px;height:98px;text-align:center;border:1px dashed #d9d9d9;border-radius:6px; padding-top:30px;}
.avatar-uploader-icon span{ font-size:16px; display: block; padding-top:10px;}
.avatar{ width:200px; height:112px; padding:20px 0;  }

.mIdcard{background:#fff;overflow:hidden;padding-bottom:3rem; margin-top:1rem;}
.mIdcard h2{ height:5rem; line-height:5rem; font-size:1.4rem;  border-bottom:solid 1px #e8e8e8; color:#272727; font-weight:normal;  text-align: center; }
.mIdcard h2 span{position: relative;}
.mIdcard h2 em{ position: absolute; top:18%; margin-left:0.2rem; }
.mIdcard p{ padding-top:1.4rem; font-size:1.3rem; padding-left:2%;  padding-bottom: 2rem;}
.mIdcard li{width:95%;font-size:1.2rem; display: flex; margin-bottom: 1rem; vertical-align: middle; padding-left:2%; }
.mIdcard li span{ display: inline-block; width:20%;padding-top:1%; text-align: right;  }
.mIdcard .upload{padding-left:2%;}
.mIdcard dl{font-size:1.2rem; }
.mIdcard dt{padding-top:1.4rem;}
.mIdcard i{ display:block; width:180px; height:108px; padding:10px; background:#f0eee7; border-radius:5px;margin:15px auto;}
.mIdcard .example{ color:#18abff; display:block;  text-align: center;}
.mIdcard .btn{text-align:center; margin-top:64px; width:100%;}
.mIdcard button{width:90%; height:3rem; line-height:3rem;text-align:center; font-size:1.2rem;border:solid 1px #1890ff; background:#1890ff;color:#fff;border-radius: 0.2rem; cursor: pointer;}
.mIdcard .ant-form-item{display:block; margin: 0 auto; width:90%; height:3rem; line-height:3rem;text-align:center; font-size:1.2rem;border:solid 1px #1890ff; background:#1890ff;color:#fff;border-radius: 0.2rem; cursor: pointer;}
.mIdcard button.unable{border:solid 1px #d9d9d9; background:#f5f5f5;color:#b7b7b7;}
.mIdcard .comment{margin-top:1.2rem; font-size: 0.7rem;}
</style>
<script>
	export default {
		name: 'auth',
		methods: {
			showExample(index,isMobile)
			{
				var src="";
				var width=0;
				if(isMobile)
					width=90;
				else
					width=100;
				if(index==1)
					src="/static/images/FrontImg.png";
				else if(index==2)
					src="/static/images/BackImg.png";
				else if(index==3)
					src="/static/images/HeldImg.png";



				if(isMobile){
					this.$alert('<img src="'+src+'" width="'+width+'%" />', '证件上传示例', {
					dangerouslyUseHTMLString: true,
					showClose:false,
					confirmButtonText:"知道了",
					confirmButtonClass:"fr",
					customClass:'mfuli-message-box'
					}).catch(() => {});
				}else{
					this.$alert('<img src="'+src+'" width="'+width+'%" />', '证件上传示例', {
					dangerouslyUseHTMLString: true,
					showClose:false,
					confirmButtonText:"知道了",
					confirmButtonClass:"fr"
					}).catch(() => {});
				}
			},
			showExample1(index,isMobile)
			{
				var src="";
				var width=0;
				if(isMobile)
					width=90;
				else
					width=100;

				if(index==1)
					src=this.BinaryImg;
				else if(index==2)
					src=this.BinaryImg1;
				else if(index==3)
					src=this.BinaryImg2;

				if(isMobile){
					this.$alert('<img src="'+src+'" width="'+width+'%" />', '', {
					dangerouslyUseHTMLString: true,
					showClose:true,
					showConfirmButton:false,
					customClass:'mfuli-message-box'
					}).catch(() => {});
				}else{
					this.$alert('<img src="'+src+'" width="'+width+'%" />', '', {
					dangerouslyUseHTMLString: true,
					showClose:true,
					showConfirmButton:false
					}).catch(() => {});
				}
			},
			showPopover()
			{
				this.$alert("实名认证通过后才能参加游戏代练师技能认定考试，我们会严格保密您的个人信息。", '为什么要实名认证？', {confirmButtonText: '确定',customClass:'mfuli-message-box'});
			},
			VerifyName(){
				const self = this;
				if(self.name=="")
					self.msg="请输入姓名";
				else{
					self.msg="";
				}
			},
			VerifyCertificate(){
				const self = this;
				var type=self.changeType();
				if(type==1)
				{
					//验证身份证
					if(self.idcard=="")
						self.msg1="请输入身份证号";
					else{
						var b=self.checkIDCard(self.idcard);
						if(!b){
							self.msg1="身份证号不合法";
						}else{
							self.msg1="";
						}
					}
				}else if(type==2){
					//验证港澳通行证
					if(self.idcard=="")
						self.msg1="请输入港澳通行证";
					else{
						var b=self.checkgaCard(self.idcard);
						if(!b){
							self.msg1="港澳通行证不合法";
						}else{
							self.msg1="";
						}
					}
				}else if(type==3){
					//验证台湾通行证
					if(self.idcard=="")
						self.msg1="请输入台湾通行证";
					else{
						var b=self.checktwCard(self.idcard);
						if(!b){
							self.msg1="台湾通行证不合法";
						}else{
							self.msg1="";
						}
					}
				}else if(type==4){
					//验证外国护照
					if(self.idcard=="")
						self.msg1="请输入外国护照";
					else{
						var b=self.checkgwCard(self.idcard);
						if(!b){
							self.msg1="外国护照不合法";
						}else{
							self.msg1="";
						}
					}
				}
			},
			checkIDCard (number) {
				var partten = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;  //身份证
				return partten.test(number);
			},
			checkgaCard(number){
				//var partten = /^[CW]\d{8}$/;//港澳通行证
				//return partten.test(number);
				return true;
			},
			checktwCard(number){
				var partten = /^[a-zA-Z][0-9]{9}$/;//台湾通行证
				return partten.test(number);
			},
			checkgwCard(number){
				var partten =/^[a-zA-Z0-9]{3,21}$/;   //护照
				return partten.test(number);
			},
			changeType(){
				if(this.selectType=="身份证号")
					return 1;
				else if(this.selectType=="港澳通行证")
					return 2;
				else if(this.selectType=="台湾通行证")
					return 3;
				else if(this.selectType=="外国护照")
					return 4;

			},
			changeType1(val){
				if(val==1)
					return "身份证号";
				else if(val==2)
					return "港澳通行证";
				else if(val==3)
					return "台湾通行证";
				else if(val==4)
					return "外国护照";
			},
			checkEdit()
			{
				//0  没有实名认证;   10	处理中;   11	认证通过;  12	认证失败;
				if(this.status==0)
					this.isabled=false;
				else if(this.status==10)
					this.isabled=true;
				else if(this.status==11)
					this.isabled=true;
				else if(this.status==12)
					this.isabled=false;
			},
			uploadFile: function (fileObj) {     //上传图片成功后发布订单
				var file=fileObj.file;
				if(file.uid==this.fileUid){
					var b=this.checkUpload(file);
					if(b){
						const loading = this.$loading(this.loading);
						const self = this;
						var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function(e) {
              let image = new Image(); //新建一个img标签（还没嵌入DOM节点)
              image.src = e.target.result; //将图片的路径设成file路径
              image.onload = function(event) {
                if(image.width>1024){
                  //压缩图片
                  let canvas = document.createElement('canvas');
                  let context = canvas.getContext('2d');
                  canvas.width = 900;    //压缩后图片的大小
                  canvas.height = 900*image.height/image.width;
                  context.drawImage(image, 0, 0, canvas.width, canvas.height);
                  image.src = canvas.toDataURL('image/jpeg',0.92);
                }

                // event.target.result 即为图片的Base64编码字符串
                var imsJson = [{
                  "value": image.src,
                  "name":'111'
                }];

                var json={"file":imsJson }
                self.http.ajaxPost('ImgBase64Upload',json,"",function(data){
                  loading.close();
                  if(data.ReturnCode == 1){
                    self.frontImgUrl=data.Result[0];
                  }else{
                    self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
                  }
                },function(res){ loading.close();self.$alert(res, '错误', {confirmButtonText: '确定'});});
              }
            }
					}else{
						this.fileUid=0;
						this.BinaryImg='';
					}
				}
			},
			uploadFile1: function (fileObj) {     //上传图片成功后发布订单
				var file=fileObj.file;
				if(file.uid==this.fileUid1){
					var b=this.checkUpload(file);
					if(b){
						const loading = this.$loading(this.loading);
						const self = this;
						var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function(e) {

              let image = new Image(); //新建一个img标签（还没嵌入DOM节点)
              image.src = e.target.result; //将图片的路径设成file路径
              image.onload = function(event) {

               if(image.width>1024){
                 //压缩图片
                 let canvas = document.createElement('canvas');
                 let context = canvas.getContext('2d');
                 canvas.width = 900;    //压缩后图片的大小
                 canvas.height = 900*image.height/image.width;
                 context.drawImage(image, 0, 0, canvas.width, canvas.height);
                 image.src = canvas.toDataURL('image/jpeg',0.92);
               }

                // event.target.result 即为图片的Base64编码字符串
                var imsJson = [{
                  "value": image.src,
                  "name":'111'
                }];

                var json={"file":imsJson }
                self.http.ajaxPost('ImgBase64Upload',json,"",function(data){
                  loading.close();
                  if(data.ReturnCode == 1){
                    self.backImgUrl=data.Result[0];
                  }else{
                    self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
                  }
                },function(res){ loading.close();self.$alert(res, '错误', {confirmButtonText: '确定'});});
              }
            }

					}else{
						this.fileUid1=0;
						this.BinaryImg1='';
					}
				}
			},
			uploadFile2: function (fileObj) {     //上传图片成功后发布订单
				var file=fileObj.file;
				if(file.uid==this.fileUid2){
					var b=this.checkUpload(file);
					if(b){
						const loading = this.$loading(this.loading);
						const self = this;
						var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function(e) {
              let image = new Image(); //新建一个img标签（还没嵌入DOM节点)
              image.src = e.target.result; //将图片的路径设成file路径
              image.onload = function(event) {
                if(image.width>1024){
                  //压缩图片
                  let canvas = document.createElement('canvas');
                  let context = canvas.getContext('2d');
                  canvas.width = 900;    //压缩后图片的大小
                  canvas.height = 900*image.height/image.width;
                  context.drawImage(image, 0, 0, canvas.width, canvas.height);
                  image.src = canvas.toDataURL('image/jpeg',0.92);
                }

                // event.target.result 即为图片的Base64编码字符串
                var imsJson = [{
                  "value": image.src,
                  "name":'111'
                }];

                var json={"file":imsJson }
                self.http.ajaxPost('ImgBase64Upload',json,"",function(data){
                  loading.close();
                  if(data.ReturnCode == 1){
                    self.heldImgUrl=data.Result[0];
                  }else{
                    self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
                  }
                },function(res){ loading.close();self.$alert(res, '错误', {confirmButtonText: '确定'});});
              }
            }
					}else{
						this.fileUid2=0;
						this.BinaryImg2='';
					}
				}
			},
			checkUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isGIF = file.type === 'image/gif';
				const isPNG = file.type === 'image/png';
				const isBMP = file.type === 'image/bmp';
				const isLt2M = file.size / 1024 / 1024 < 10;

				if (!isJPG && !isGIF && !isPNG && !isBMP) {
					if(this.isMobile){
						this.$alert('上传图片必须是JPG/GIF/PNG/BMP 格式!', '提示', {confirmButtonText: '确定',customClass:'mfuli-message-box'});
					}else{
						this.$alert('上传图片必须是JPG/GIF/PNG/BMP 格式!', '提示', {confirmButtonText: '确定'});
					}
				}else if(!isLt2M) {
					if(this.isMobile){
						this.$alert('上传图片大小不能超过 10MB!', '提示', {confirmButtonText: '确定',customClass:'mfuli-message-box'});
					}else{
						this.$alert('上传图片大小不能超过 10MB!', '提示', {confirmButtonText: '确定'});
					}
				}
				return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
			},
			changeFile(file,fileList){
				this.fileUid=file.uid;
				this.BinaryImg=file.url;
			},
			changeFile1(file,fileList){
				this.fileUid1=file.uid;
				this.BinaryImg1=file.url;
			},
			changeFile2(file,fileList){
				this.fileUid2=file.uid;
				this.BinaryImg2=file.url;
			},
			save()
			{
				this.VerifyName();
				this.VerifyCertificate();
				if(this.msg=='' && this.msg1=='')
				{
					if(this.frontImgUrl!='' && this.backImgUrl!='' && this.heldImgUrl!=''){
						const self = this;
						const loading = this.$loading(this.loading);
						var selectType=this.changeType();
						var action="insert";
						if(self.status==0)
							var action="insert";
						else if(self.status==12)
							var action="update";
						//提交实名认证
						var imsJson = [{
							"type": selectType,
							"realName":self.name,
							"idCard":self.idcard,
							"status":10,
							"cardFrontImg":self.frontImgUrl,
							"cardBackImg":self.backImgUrl,
							"handHeldImg":self.heldImgUrl,
							"comment":'',
							"action":action,
						}];

						var json={"idcard":imsJson }
						self.http.ajaxPost('SubmitIDCard',json,"",function(data){
							loading.close();
							if(data.ReturnCode == 1){
								if(data.Result>0)
									self.init();
								else{
									if(self.isMobile){
										self.$alert("提交失败，请稍后重试", '温馨提示', {confirmButtonText: '确定',customClass:'mfuli-message-box'});
									}else{
										self.$alert("提交失败，请稍后重试", '温馨提示', {confirmButtonText: '确定'});
									}
								}
							}else{
								self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定'});
							}
						},function(res){ loading.close();self.$alert(res, '错误', {confirmButtonText: '确定'});});

					}else{
						if(this.isMobile){
							this.$alert('请上传正反面和手持证件照片!', '提示', {confirmButtonText: '确定',customClass:'mfuli-message-box'});
						}else{
							this.$alert('请上传正反面和手持证件照片!', '提示', {confirmButtonText: '确定'});
						}
					}
				}
			},
			init(){
				const self = this;
				var data= self.common.GetlocalStorage("UnLockUserData");
				var userId=JSON.parse(data).UserID;
				self.http.ajaxGet("GetIDCard?UserID="+userId,function(res){
					if(res.ReturnCode == 1){
						if(res.Result.length>0){
							self.selectType=self.changeType1(res.Result[0].Type);
							self.name=res.Result[0].RealName;
							self.idcard=res.Result[0].IDCard;
							self.status=res.Result[0].Status;
							self.checkEdit();
							self.frontImgUrl=res.Result[0].CardFrontImg;
							self.BinaryImg=res.Result[0].TempCardFrontImg;
							self.backImgUrl=res.Result[0].CardBackImg;
							self.BinaryImg1=res.Result[0].TempCardBackImg;
							self.heldImgUrl=res.Result[0].HandHeldImg;
							self.BinaryImg2=res.Result[0].TempHandHeldImg;
							self.comment=res.Result[0].Comment;
						}
					}else if(res.ReturnCode == 3){
						if(self.isMobile){
							self.$alert(res.Message, '', {
							confirmButtonText: '确定',
							customClass:'mfuli-message-box',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/sign-up'});
							}
							});
						}else{
							self.$alert(res.Message, '', {
							confirmButtonText: '确定',
							type:"info",
							showClose:false,
							callback: action => {
								self.$router.push({path:'/sign-up'});
							}
							});
						}
					}
					else{
						self.$alert(res.Message, '温馨提示', {confirmButtonText: '确定'});
					}
					},function(err){
						self.$alert(err, '错误', {confirmButtonText: '确定'});
				})
			}
		},
		data() {
			return {
				visible:false,
				name:'',
				idcard:'',
				selectType:'身份证号',
				msg:"",
				msg1:"",
				BinaryImg:'',
				fileUid:0,
				BinaryImg1:'',
				fileUid1:0,
				BinaryImg2:'',
				fileUid2:0,

				frontImgUrl:'',
				backImgUrl:'',
				heldImgUrl:'',
				status:0,                      //0  没有实名认证;   10	处理中;   11	认证通过;  12	认证失败;
				isabled:false,                 //是否禁用
				comment:''
			}
		},
		computed:{
			domain(){
				return this.$store.getters.domain+'ImgBase64Upload';
			},
			myHeader(){
				return {"content-type":"multipart/form-data"}
			},
			loading(){
				return this.$store.getters.loadingPara;
			},
			isMobile(){
				return this.common.isMobile();
			}
		},
		mounted: function () {
			this.init();
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/auth.vue